import React, { Component } from 'react';
import axios from '../../../axios';
import { Route } from 'react-router-dom';

import Post from '../../../components/Post/Post';
import './Posts.css';
import FullPost from '../FullPost/FullPost';

class Posts extends Component {
	state = {
		posts: [],
		amount: 6,
		limit: false,
	};

	getPosts = () => {
		axios
			.get('/posts')
			.then(response => {
				const posts = response.data.slice(0, this.state.amount);
				const updatedPosts = posts.map(post => {
					return {
						...post,
					};
				});
				this.setState({ posts: updatedPosts });
			})
			.catch(error => {
				console.log(error);
			});
	};

	componentDidMount() {
		this.getPosts();
	}

	postSelectedHandler = id => {
		this.props.history.push({ pathname: '/posts/' + id });
	};

	seeMore = () => {
		if (this.state.amount >= 100) {
			this.setState({ limit: true });
		} else {
			this.setState({ amount: this.state.amount + 6 });
			this.getPosts();
		}
	};

	render() {
		let seeMore = null;
		let posts = <p style={{ textAlign: 'center' }}>Something went wrong!</p>;
		if (!this.state.error) {
			posts = this.state.posts.map(post => {
				return (
					<Post
						key={post.id}
						title={post.title}
						postNumber={post.id}
						clicked={() => this.postSelectedHandler(post.id)}
					/>
				);
			});
		}

		if (this.state.limit) {
			seeMore = (
				<h2 className="Limit">
					Sorry.
					<br />
					There's no more posts available for you to go through.
				</h2>
			);
		} else {
			seeMore = (
				<button className="SeeMore" onClick={this.seeMore}>
					See more posts
				</button>
			);
		}

		console.log(this.props);
		return (
			<div>
				<section className="Posts">
					{posts}
					<div className="SeeMoreBtn">{seeMore}</div>
				</section>

				<Route
					path={this.props.match.url + '/:id'}
					exact
					component={FullPost}
				/>
			</div>
		);
	}
}

export default Posts;



// WEBPACK FOOTER //
// ./src/containers/Blog/Posts/Posts.js